export default class CharacterCounter {
    /**
     * Create the CharacterCounter instance.
     * @param rootElement Wrapper element containing the textarea and counter display.
     */
    constructor(rootElement) {
        this.root = rootElement;
        if (this.root.classList.contains('character-counter-initialized')) {
            return;
        }
        this.textarea = this.root.querySelector('[data-character-counter]');
        this.counterDisplay = this.root.querySelector('.counter-display');
        if (!this.textarea || !this.counterDisplay) {
            return;
        }
        this.maxLength = parseInt(this.textarea.getAttribute('maxlength') || '0', 10);
        this.init();
        this.root.classList.add('character-counter-initialized');
    }
    /**
     * Initialize event listeners and set initial counter value.
     */
    init() {
        if (!this.textarea || !this.counterDisplay) {
            return;
        }
        this.textarea.addEventListener('input', () => this.updateCounter());
        this.textarea.addEventListener('paste', () => {
            setTimeout(() => this.updateCounter(), 0);
        });
        this.updateCounter();
    }
    /**
     * Update the character counter display.
     */
    updateCounter() {
        if (!this.textarea || !this.counterDisplay) {
            return;
        }
        const currentLength = this.textarea.value.length;
        this.counterDisplay.textContent = `${currentLength}/${this.maxLength}`;
    }
}
